/**
 * Detect which "surface" of the app this domain serves.
 * - admin.* → admin console (admin/staff login required)
 * - tv.*    → TV display only (no auth)
 * - else    → player app (apex + app.* and any preview/dev domain)
 *
 * Override via ?as=admin|tv|player query param for local testing.
 */
const SURFACES = ["admin", "tv", "player"];

export function getSurface() {
  try {
    const url = new URL(window.location.href);
    const override = url.searchParams.get("as");
    if (override && SURFACES.includes(override)) return override;
    const host = window.location.hostname.toLowerCase();
    if (host.startsWith("admin.")) return "admin";
    if (host.startsWith("tv.")) return "tv";
    return "player";
  } catch {
    return "player";
  }
}

export const SURFACE = getSurface();
export const IS_ADMIN_SURFACE = SURFACE === "admin";
export const IS_TV_SURFACE = SURFACE === "tv";
export const IS_PLAYER_SURFACE = SURFACE === "player";
